import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ElementRef, HostListener } from '@angular/core';

import { CfCoreGalleryHelperService } from './cf-core-gallery-helper.service';
export class CfCoreGalleryPreviewComponent implements OnChanges {

    src: string;
    description: string;
    showSpinner = false;

     images: string[];
     descriptions: string[];
     showDescription: boolean;
     swipe: boolean;
     fullscreen: boolean;
     closeOnClick: boolean;
     keyboardNavigation: boolean;

     onClose = new EventEmitter();
private index = 0;
private loadedList: string[] = [];
private isOpen = false;
/**
 * @param {?} elementRef
 * @param {?} helperService
 */
constructor(private elementRef: ElementRef,
private helperService: CfCoreGalleryHelperService) {}
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges): void {
        if (changes['swipe']) {
            this.helperService.manageSwipe(this.swipe, this.elementRef,
            'preview', () => this.showNext(), () => this.showPrev());
        }
    }
/**
 * @param {?} e
 * @return {?}
 */
onKeyDown(e: KeyboardEvent) {
        if (this.isOpen && this.keyboardNavigation) {
            if (this.isKeyboardPrev(e)) {
                this.showPrev();
            } else if (this.isKeyboardNext(e)) {
                this.showNext();
            }
        }
    }
/**
 * @param {?} index
 * @return {?}
 */
open(index: number): void {
        this.index = index;
        this.isOpen = true;
        this.show();
    }
/**
 * @return {?}
 */
close(): void {
        this.isOpen = false;
        this.closeFullscreen();
        this.onClose.emit();
    }
/**
 * @return {?}
 */
loaded(): void {
        this.showSpinner = false;
        this.loadedList.push(this.src);
    }
/**
 * @return {?}
 */
showNext(): void {
        if (this.canShowNext()) {
            this.index++;
            this.show();
        }
    }
/**
 * @return {?}
 */
showPrev(): void {
        if (this.canShowPrev()) {
            this.index--;
            this.show();
        }
    }
/**
 * @return {?}
 */
canShowNext(): boolean {
        if (this.images) {
            return this.index < this.images.length - 1 ? true : false;
        } else {
            return false;
        }
    }
/**
 * @return {?}
 */
canShowPrev(): boolean {
        if (this.images) {
            return this.index > 0 ? true : false;
        } else {
            return false;
        }
    }
/**
 * @return {?}
 */
manageFullscreen(): void {
        if (this.fullscreen) {
            const /** @type {?} */ doc = /** @type {?} */(( <any>document));

            if (!doc.fullscreenElement && !doc.mozFullScreenElement
                && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                this.openFullscreen();
            } else {
                this.closeFullscreen();
            }
        }
    }
/**
 * @param {?} e
 * @return {?}
 */
private isKeyboardNext(e: KeyboardEvent): boolean {
        if (e.keyCode === 39) {
            return true;
        } else {
            return false;
        }
    }
/**
 * @param {?} e
 * @return {?}
 */
private isKeyboardPrev(e: KeyboardEvent): boolean {
        if (e.keyCode === 37) {
            return true;
        } else {
            return false;
        }
    }
/**
 * @return {?}
 */
private openFullscreen(): void {

        const /** @type {?} */ doc = /** @type {?} */(( <any>document));
        const /** @type {?} */ element = /** @type {?} */(( <any>document.documentElement));

        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        }
    }
/**
 * @return {?}
 */
private closeFullscreen(): void {

        const /** @type {?} */ doc = /** @type {?} */(( <any>document));

        if (doc.exitFullscreen) {
            doc.exitFullscreen();
        } else if (doc.msExitFullscreen) {
            doc.msExitFullscreen();
        } else if (doc.mozCancelFullScreen) {
            doc.mozCancelFullScreen();
        } else if (doc.webkitExitFullscreen) {
            doc.webkitExitFullscreen();
        }
    }
/**
 * @return {?}
 */
private show() {
        this.src = this.images[this.index];
        this.description = this.descriptions[this.index];

        if (this.loadedList.indexOf(this.src) === -1) {
            this.showSpinner = true;
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'cf-core-gallery-preview',
    template: "<cf-core-gallery-arrows (onPrevClick)=\"showPrev()\" (onNextClick)=\"showNext()\" [prevDisabled]=\"!canShowPrev()\" [nextDisabled]=\"!canShowNext()\" ></cf-core-gallery-arrows> <i class=\"fa fa-times-circle\" aria-hidden=\"true\" (click)=\"close()\"></i> <i class=\"fa fa-arrows-alt\" aria-hidden=\"true\" *ngIf=\"fullscreen\" (click)=\"manageFullscreen()\"></i> <div class=\"cf-core-spinner-wrapper cf-core-gallery-center\" [class.cf-core-gallery-active]=\"showSpinner\"> <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\" aria-hidden=\"true\"></i> </div> <div class=\"cf-core-gallery-preview-wrapper\" (click)=\"closeOnClick && close()\"> <div class=\"cf-core-gallery-preview-img-wrapper\"> <img class=\"cf-core-gallery-preview-img cf-core-gallery-center\" [src]=\"src ? src : '#'\" (load)=\"loaded()\" (click)=\"$event.stopPropagation()\" [class.cf-core-gallery-active]=\"!showSpinner\"/> </div> <div class=\"cf-core-gallery-preview-text\" *ngIf=\"showDescription && description\">{{ description }}</div> </div>",
    styles: [":host(.cf-core-gallery-active) { width: 100%; height: 100%; position: fixed; left: 0px; top: 0px; background: rgba(0, 0, 0, 0.7); z-index: 10000; display: inline-block; } :host(.cf-core-gallery-active) /deep/ .fa.fa-arrow-circle-left, :host(.cf-core-gallery-active) /deep/ .fa.fa-arrow-circle-right { font-size: 50px; } :host { display: none; } .cf-core-gallery-preview-img { opacity: 0; max-width: 90%; max-height: 90%; transition: opacity 0.5s ease-in-out; } .cf-core-gallery-preview-img.cf-core-gallery-active { opacity: 1; } .fa.fa-spinner { font-size: 50px; left: 0px; display: inline-block; } .fa.fa-times-circle { right: 10px; top: 10px; font-size: 30px; cursor: pointer; } .fa.fa-arrows-alt { top: 13px; right: 50px; cursor: pointer; } .cf-core-spinner-wrapper { width: 50px; height: 50px; display: none; } .cf-core-spinner-wrapper.cf-core-gallery-active { display: inline-block; } .cf-core-gallery-center { position: absolute; left: 0; right: 0; bottom: 0; margin: auto; top: 0; } .cf-core-gallery-preview-text { width: 100%; background: rgba(0, 0, 0, 0.7); padding: 10px; text-align: center; color: white; font-size: 16px; flex: 0 1 auto; } .cf-core-gallery-preview-wrapper { width: 100%; height: 100%; display: flex; flex-flow: column; } .cf-core-gallery-preview-img-wrapper { flex: 1 1 auto; position: relative; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: CfCoreGalleryHelperService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'images': [{ type: Input },],
'descriptions': [{ type: Input },],
'showDescription': [{ type: Input },],
'swipe': [{ type: Input },],
'fullscreen': [{ type: Input },],
'closeOnClick': [{ type: Input },],
'keyboardNavigation': [{ type: Input },],
'onClose': [{ type: Output },],
'onKeyDown': [{ type: HostListener, args: ['window:keydown', ['$event'], ] },],
};
}

function CfCoreGalleryPreviewComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreGalleryPreviewComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfCoreGalleryPreviewComponent.ctorParameters;
/** @type {?} */
CfCoreGalleryPreviewComponent.propDecorators;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.src;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.description;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.showSpinner;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.images;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.descriptions;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.showDescription;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.swipe;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.fullscreen;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.closeOnClick;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.keyboardNavigation;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.onClose;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.index;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.loadedList;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.isOpen;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.elementRef;
/** @type {?} */
CfCoreGalleryPreviewComponent.prototype.helperService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
